// Actions
import {
  SET_PROSPECTIVE_STUDENTS,
  SET_PARENTS_OF_PROSPECTS,
  SET_CURRENT_STUDENT,
  SET_ALUMNI,
  SET_FACULTY,
  SET_GUIDANCE_COUNSELOR,
  SET_VETERAN,
  SET_VISITOR_TYPE_STATE
} from "../actionTypes/visitorType.actionTypes";

// Classes
import { VisitorTypeReducerState } from "../classes/visitorType.classes";

const initialState = new VisitorTypeReducerState();

export const VisitorTypeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PROSPECTIVE_STUDENTS:
      return { ...state, prospectiveStudents: action.payload };
    case SET_PARENTS_OF_PROSPECTS:
      return { ...state, parentsOfProspects: action.payload };
    case SET_CURRENT_STUDENT:
      return { ...state, currentStudent: action.payload };
    case SET_ALUMNI:
      return { ...state, alumni: action.payload };
    case SET_FACULTY:
      return { ...state, faculty: action.payload };
    case SET_GUIDANCE_COUNSELOR:
      return { ...state, guidanceCounselor: action.payload };
    case SET_VETERAN:
      return { ...state, veteran: action.payload };
    case SET_VISITOR_TYPE_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
